import dynamic from 'next/dynamic'

export const HorizontalScroller = dynamic(() => import('./horizontal-scroller'))
